import { create } from "zustand";

const UNLOCKED_KEY = "glucose-admin-unlocked";
const PASSWORD_KEY = "glucose-admin-password";

interface AdminAccessState {
    isUnlocked: boolean;
    unlock: (password: string) => boolean;
    lock: () => void;
    getPassword: () => string | null;
}

function readUnlocked(): boolean {
    return sessionStorage.getItem(UNLOCKED_KEY) === "true";
}

export const useAdminAccess = create<AdminAccessState>((set) => ({
    isUnlocked: typeof window !== "undefined" ? readUnlocked() : false,

    unlock: (password: string) => {
        const expected = import.meta.env.VITE_ADMIN_PASSWORD;
        if (!expected || password !== expected) {
            return false;
        }

        sessionStorage.setItem(UNLOCKED_KEY, "true");
        sessionStorage.setItem(PASSWORD_KEY, password);
        set({ isUnlocked: true });
        return true;
    },

    lock: () => {
        sessionStorage.removeItem(UNLOCKED_KEY);
        sessionStorage.removeItem(PASSWORD_KEY);
        set({ isUnlocked: false });
    },

    getPassword: () => sessionStorage.getItem(PASSWORD_KEY),
}));

export function getStoredAdminPassword(): string | null {
    return sessionStorage.getItem(PASSWORD_KEY);
}
